import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useGetOne } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { Currency } from 'types/embedded/currency';
import { RefundChargebackReportSummary } from 'types/embedded/refundChargebackReport';
import { convertReactAdminIdToHydraId, formatCurrency } from 'utils';

type Props = {
  source: keyof RefundChargebackReportSummary;
  conversionCurrency: any;
} & Omit<FunctionFieldProps, 'render'>;

export const RefundChargebackReportSummaryDatagridFooterAmountField: React.FC<Props> = ({
  source,
  conversionCurrency,
  ...rest
}) => {
  const { data: currency } = useGetOne<Currency>(
    Resources.Currencies,
    {
      id: convertReactAdminIdToHydraId(conversionCurrency, Resources.Currencies),
    },
    { enabled: !!conversionCurrency },
  );

  return (
    <FunctionField
      render={(record: RefundChargebackReportSummary) => {
        if (Number(record?.[source]) === 0) {
          return EMPTY_FIELD;
        }

        return (
          <Typography variant="body2">
            {formatCurrency(Number(record?.[source]))}{' '}
            <Typography component="span" fontWeight={500} variant="body2">
              {currency?.alphaCode}
            </Typography>
          </Typography>
        );
      }}
      source={source}
      {...rest}
    />
  );
};
